import { create } from 'zustand';
import { Credit, Fees, Therapist } from '../../../core/types';
import * as api from '../../../core/api/services';
import { storageMgt } from '../../../core/utils/storage';
import { User } from '../../../core/types';

interface SessionsState {
  getSessionCredit: () => Promise<Credit>;
  fees: () => Promise<Fees>;
  createCredit: (data: any) => Promise<Credit>;
  therapistInfo: (id: string) => Promise<Therapist>;
  retrieve: () => User | null;
}

export const useSessionsStore = create<SessionsState>(() => ({
  getSessionCredit: async () => {
    try {
      const user = storageMgt.getUser();
      if (!user?.id) return { quantity: 0 };
      return await api.getSessionCredit(user.id);
    } catch {
      return { quantity: 0 };
    }
  },

  fees: async () => {
    try {
      return await api.fetchFees();
        } catch {
      return { fee: 100 };
    }
  },

  createCredit: async (data: any) => {
    try {
      return await api.createCredit(data);
    } catch {
      return { quantity: 0 } as Credit;  // match Credit shape
    }
  },

  therapistInfo: async (id: string) => {
    try {
      return await api.fetchTherapistById(id);
    } catch {
      return { name: '', rate: 0 };
    }
  },

  retrieve: () => storageMgt.getUser(),
}));
